import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  tos: {
    fontSize: '.5rem',
    alignItems: 'center',
    color: '#33A6D7',
  },
}));
